import React from 'react'
import { useRequestPreSend } from "@rpldy/chunked-uploady";
import Cookies from 'js-cookie'
import { useUploader } from './Uploader';
import { findQueueItem } from '../../../services/file-explorer/uploader/uploaderUtils';

const xsrfToken = Cookies.get('XSRF-TOKEN');

const UploaderApiCallModifier = () => {
    let uploader = useUploader();
    useRequestPreSend(({ items }) => {
        let queueItem = findQueueItem(uploader.state.queue, items[0].id);
        let params = {
            path: queueItem.path,
            root_path: queueItem.rootPath
        }
        const tagIds = queueItem.tagIds;
        for (let index in tagIds) {
            params[`tags[${index}]`] = tagIds[index];
        }
        return {
            options: {
                destination: {
                    headers: {
                        'x-xsrf-token': xsrfToken
                    },
                    params: params,
                }
            }
        };
    });
    return <></>;
}
export default UploaderApiCallModifier;